import React, { forwardRef, useImperativeHandle, useState } from 'react';
import type { CReactNode, SimpleFunc, SimplePromise } from '@bluevision/tools';
import type { FormInstance } from 'antd';
import { Form } from 'antd';
import { Button, Modal, Spacing } from '@bluevision/components';
import type { ModalProps } from '@bluevision/components/types/components/Modal/type';
import { formLayout, useRequest } from '@bluevision/tools';
import type { FormProps } from 'antd/es/form';
import type { ObjectMap } from '@bluevision/tools';

export type ICEditModalFormProps = {
  onSuccess?: SimpleFunc;
  onError?: SimpleFunc;
  onRes?: SimpleFunc;
  btnText?: CReactNode;
  service: SimplePromise;
  onClose?: SimpleFunc;
  formProps?: FormProps;
  getResponse?: boolean;
  disabled?: boolean;
  width?: number;
  title?: CReactNode;
  footer?: CReactNode;
  submitText?: CReactNode;
  size?: ModalProps['size'];
  errorClose?: boolean;
  bodyStyle?: React.CSSProperties;
  children?: CReactNode;
  extraParams?: ObjectMap; // 额外参数 表单项参数以外的
  className?: string;
};

const { layout } = formLayout;

const CEditModalForm = forwardRef<{ form: FormInstance }, ICEditModalFormProps>((props, ref) => {
  const {
    children,
    disabled,
    onSuccess,
    onError,
    btnText,
    service,
    onClose,
    getResponse,
    formProps,
    width = 480,
    title,
    onRes,
    footer = undefined,
    submitText,

    errorClose,
    bodyStyle,
    extraParams,
    className,
  } = props;

  const [form] = Form.useForm();
  useImperativeHandle(ref, () => ({
    form,
  }));

  const [show, setShow] = useState(true);
  const [success, setSuccess] = useState(null);
  const { loading, request } = useRequest(
    service,
    (res) => {
      setSuccess(res || true);
      setShow(false);
      onRes?.(res);
    },
    (error) => {
      // if (isArray(error)) {
      //   onError?.(error);
      // }
      onError?.(error);
      if (errorClose) {
        setShow(false);
      }
    },
  );

  const onFinish = () => {
    form.validateFields().then((values) => {
      request({ ...values, ...extraParams });
    });
  };

  const afterClose = () => {
    if (success) {
      onSuccess?.(getResponse ? success : undefined);
    }
    onClose?.(success);
  };

  return (
    <Modal
      footer={
        <div style={{ textAlign: 'right' }}>
          <Spacing justify='end'>
            {footer}
            <Button
              type='primary'
              htmlType='submit'
              loading={loading}
              disabled={disabled}
              onClick={onFinish}
            >
              <span>{submitText ?? btnText}</span>
            </Button>
          </Spacing>
        </div>
      }
      onCancel={() => setShow(false)}
      afterClose={afterClose}
      visible={show}
      width={width}
      maskClosable={false}
      destroyOnClose
      title={title ?? btnText}
      bodyStyle={{ padding: '1px 0', ...bodyStyle }}
      centered
      className={className}
    >
      <div style={{ width: width - 60, margin: '24px auto' }}>
        <Form
          name='c-edit-model'
          {...layout}
          onFinish={onFinish}
          autoComplete='off'
          preserve={false}
          form={form}
          {...formProps}
        >
          {children}
        </Form>
      </div>
    </Modal>
  );
});

export default CEditModalForm;
